<template>
    <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    @close="$emit('close')"
    custom-class="share-modal"
    >

        <div class="share-btn-group">
            <share-button
                type="line"
                :href="lineUrl"
                icon="fab fa-line"
            >LINEでシェア</share-button>

            <share-button
                type="twitter"
                :href="twitterUrl"
                icon="fab fa-twitter"
            >Twitterでシェア</share-button>

            <share-button
                type="facebook"
                :href="facebookUrl"
                icon="fab fa-facebook-f"
            >Facebookでシェア</share-button>

            <share-button
                type="email"
                :href="emailUrl"
                icon="fas fa-envelope"
            >Emailでシェア</share-button>

        </div>

        <span slot="footer" class="dialog-footer">
            <el-button label-width="200" @click="$emit('close')">キャンセル</el-button>
        </span>
    </el-dialog>
</template>

<script>
import ShareButton from '../../../components/atoms/button/ShareButton'
import Share from '../../../utils/share'
import { numberFormat } from '../../../utils/formatter'

export default {
    name: 'ShareModal',

    components: {
        ShareButton
    },

    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        property: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            title: '物件をシェアしますか？'
        }
    },

    computed: {
        shareText() {
            return this.createText(this.property)
        },
        shareUrl() {
            return location.protocol + '//' + location.host + '/detail/' + this.property.id
        },
        lineUrl() {
            return Share.createLineShareUrl(this.shareText, this.shareUrl)
        },
        twitterUrl() {
            return Share.createTwitterShareUrl(this.shareText, this.shareUrl)
        },
        facebookUrl() {
            return Share.createFacebookShareUrl(this.shareUrl)
        },
        emailUrl() {
            return Share.createEmailShareUrl(this.property.city, this.shareText, this.shareUrl)
        }
    },

    methods: {
        // shareするときの文言を作成
        // 市区町村、駅距離・最寄り駅、一種単価、価格、面積
        createText(property) {
            const cityText            = property.city
            const stationDistanceText = '駅距離' + property.distance + 'm' + ' ' + `(徒歩約${ property.walk_minutes }分)`
            const closestStationText  = '最寄り駅' + property.closest_stations
            const unitPriceText       = '一種単価' + numberFormat(property.unit_price)
            const priceText           = '価格' + numberFormat(property.land_price)
            const area                = '面積' + property.land_area_squere + '㎡'

            return cityText + '、 ' +
                stationDistanceText + '、 ' +
                closestStationText + '、 ' +
                unitPriceText + '、 ' +
                priceText + '、 ' +
                area + ' '
        },
    }
}
</script>

<style>
.share-modal {
    width: 80% !important;
    max-width: 400px !important;
}
</style>